import { urlResolve } from "../utils/url";
import { WorkspaceTabs } from "../enums";

import router from ".";

function navigateToWorkspace(oid: string | null | undefined, selectedWorkspaceTab: WorkspaceTabs) {
    let workspaceUrl: string;

    if (selectedWorkspaceTab === WorkspaceTabs.PROJECTS) {
        workspaceUrl = oid && oid !== "user"
            ? urlResolve("workspace-projects", { url: { oid } })
            : urlResolve("projects");
    } else {
        workspaceUrl = oid && oid !== "user"
            ? urlResolve("workspace-styleguides", { url: { oid } })
            : urlResolve("styleguides");
    }

    router.history.push(workspaceUrl);
}

export {
    navigateToWorkspace
};
